module.exports = __webpack_public_path__ + "static/media/water-tank.03a32362.png";